import { render, staticRenderFns } from "./AmpCustomSwiper.vue?vue&type=template&id=4e665d36&scoped=true"
import script from "./AmpCustomSwiper.vue?vue&type=script&lang=ts"
export * from "./AmpCustomSwiper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e665d36",
  null
  
)

export default component.exports